/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 会员中心接口（会员信息 + 激活码升级）</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月25日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//当前用户会员信息（vip/limit/used）
	info() {
		return Ajax.get('/member/info')
	},
	//激活码升级超级会员
	activate(code) {
		return Ajax.postJson('/member/activate', {code})
	}
};
